function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * A model to manage displayed Sync engines
 * in the Choose What to Sync screen.
 */
import _ from 'underscore';
import Backbone from 'backbone';
import Cocktail from 'cocktail';
import UrlMixin from '../lib/url-mixin';
import UserAgentMixin from '../lib/user-agent-mixin';

const t = msg => msg;
/**
 * Fields available in each engine:
 * - `checked` whether the item should be checked when CWTS opens.
 * - `id` of the engine, must be the name the browser uses.
 * - `test` if defined, function used to test whether CWTS is available
 *    for the given `userAgent`. Should return `true` or `false`.
 * - `text` to display when CWTS opens
 */


const AVAILABLE_ENGINES = [{
  checked: true,
  id: 'bookmarks',
  text: t('Bookmarks')
}, {
  checked: true,
  id: 'history',
  text: t('History')
}, {
  checked: true,
  id: 'passwords',
  text: t('Passwords')
}, {
  checked: true,
  id: 'addons',
  text: t('Add-ons')
}, {
  checked: true,
  id: 'tabs',
  text: t('Open Tabs')
}, {
  checked: true,
  id: 'prefs',
  text: t('Preferences')
}, {
  checked: true,
  id: 'addresses',
  // addresses will only be available via capabilities.
  test: () => false,
  text: t('Addresses')
}, {
  checked: true,
  id: 'creditcards',
  // credit cards will only be available via capabilities.
  test: () => false,
  text: t('Credit Cards')
}];

let SyncEngines = /*#__PURE__*/function (_Backbone$Collection) {
  _inherits(SyncEngines, _Backbone$Collection);

  var _super = _createSuper(SyncEngines);

  function SyncEngines() {
    _classCallCheck(this, SyncEngines);

    return _super.apply(this, arguments);
  }

  _createClass(SyncEngines, [{
    key: "initialize",
    value: function initialize(models) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.window = options.window;
      const engines = options.engines || this.getSupportedEngineIds();
      engines.forEach(engineId => this.addById(engineId));
    }
    /**
     * Get a list of engineIds supported by the user agent.
     *
     * @returns {String[]}
     */

  }, {
    key: "getSupportedEngineIds",
    value: function getSupportedEngineIds() {
      const userAgent = this.getUserAgent();
      const availableEngineIds = AVAILABLE_ENGINES.map(syncEngine => syncEngine.id);
      return _.filter(availableEngineIds, engineId => this.isEngineSupportedByUA(engineId, userAgent));
    }
    /**
     * Is engine with `engineId` is supported by `userAgent`
     *
     * @param {String} engineId
     * @param {Object} userAgent
     * @returns {Boolean}
     */

  }, {
    key: "isEngineSupportedByUA",
    value: function isEngineSupportedByUA(engineId, userAgent) {
      const syncEngine = SyncEngines.getEngineConfig(engineId);
      return !syncEngine.test || syncEngine.test(userAgent);
    }
    /**
     * Add a sync engine by `engineId`, if not already
     * in the collection.
     *
     * @param {String} engineId
     */

  }, {
    key: "addById",
    value: function addById(engineId) {
      const syncEngine = SyncEngines.getEngineConfig(engineId);

      if (syncEngine && !this.get(engineId)) {
        this.add(syncEngine);
      }
    }
    /**
     * Use `engineId` to get the configuration for a Sync engine.
     *
     * @static
     * @param {String} engineId
     * @returns {Object}
     */

  }], [{
    key: "getEngineConfig",
    value: function getEngineConfig(engineId) {
      return _.find(AVAILABLE_ENGINES, syncEngine => syncEngine.id === engineId);
    }
  }]);

  return SyncEngines;
}(Backbone.Collection);

Cocktail.mixin(SyncEngines, UrlMixin, UserAgentMixin);
export default SyncEngines;